import * as yup from 'yup';

export const TextComponentSchema = yup.object({
  text: yup.string().required(),
  isActive: yup.boolean().required().default(false),
});

export const UpdateTextComponentsSchema = yup.object({
  id: yup.string().required(),
  textComponents: yup.array().of(TextComponentSchema).default([]),
});

export type ITextComponent = {
  text: string;
  isActive: boolean;
};

export interface IUpdateTextComponents {
  id: string;
  textComponents: ITextComponent[];
}
